// src/components/Benefits/Benefits.js
import React, { useEffect, useState } from 'react';
import axios from '../api/axios'; // Assuming path to axios instance
import './Benefits.css';

const Benefits = () => {
  const [benefits, setBenefits] = useState([]);
  const [joinLink, setJoinLink] = useState('');
  const [loading, setLoading] = useState(true);

  const BASE_URL = 'https://blog.dietchapter.hosting.acm.org/'; 

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      // 1. Fetch Benefits (from backend API)
      const benefitsRes = await axios.get('/benefits');
      // Assume the backend structure is { title, description, imgSrc, link }
      setBenefits(benefitsRes.data);
      
      // 2. Fetch Join Link (from backend API)
      const joinLinkRes = await axios.get('/join-link');
      if (joinLinkRes.data?.link) {
        setJoinLink(joinLinkRes.data.link);
      }
      
    } catch (err) {
      console.error('Error fetching data:', err);
    } finally {
      setLoading(false);
    }
  };

  // Function to open the join form link
  const handleJoinNow = () => {
    if (joinLink) {
      window.open(joinLink, '_blank');
    } else {
      alert("Membership form link not available.");
    }
  };

  // Handle clicking on an individual benefit card (opens link if available)
  const handleBenefitClick = (link) => {
    if (link) {
        window.open(link, '_blank');
    }
  };
  
  // Helper to resolve the image path
  const formatPath = (imgSrc) => {
    // If the image is a full URL (like the old hardcoded ones), use it directly.
    // Otherwise, prepend the base path for uploaded files.
    if (imgSrc && imgSrc.startsWith('http')) {
      return imgSrc;
    }
    return `${BASE_URL}/${imgSrc.replace(/\\/g, '/')}`;
  };

  if (loading) {
    return (
        <div className="benefits-container" > {/* REMOVED: style={{paddingTop: '100px'}} */}
            <h2>Benefits</h2>
            <p style={{color: 'white'}}>Loading benefits...</p>
        </div>
    );
  }

  return (
    <div className="benefits-container">
      <h2 className="benefits-title">Benefits</h2>
      <div className="benefits-grid">
        {benefits.map((benefit) => (
          // Entire card structure replicates the old working HTML/JSX
          <div 
            key={benefit.id} 
            className="benefits-card" 
            // The click action should go on the link element itself for best accessibility,
            // but replicating the old structure where a link wrapped the content:
          >
            <a 
                href={benefit.link || "#"} // Use '#' if link is null
                target="_blank" 
                rel="noopener noreferrer"
                // Prevent navigation if there is no link
                onClick={(e) => { if (!benefit.link) e.preventDefault(); }} 
            >
              <img 
                // Image source is now dynamic from the database
                src={formatPath(benefit.imgSrc)} 
                alt={benefit.title} 
                className="benefits-image" 
              />
            </a>
            
            <h3>{benefit.title}</h3>
            <p>{benefit.description}</p>
            
            {/* The Learn More link element */}
            <a
              href={benefit.link || "#"} 
              target="_blank"
              rel="noopener noreferrer"
              className="benefits-link"
              onClick={(e) => { if (!benefit.link) e.preventDefault(); }}
            >
              Learn More
            </a>
          </div>
        ))}
      </div>
      <button className="member-button" onClick={handleJoinNow}>
        Become a Member
      </button>
    </div>
  );
};

export default Benefits;